<template>
  <div class="bg-surface-container rounded-large">
    <h4 class="text-title-small inline-flex items-start gap-2 p-4 pb-2">
      <span class="bg-primary-container text-on-primary-container rounded-extra-small px-2 py-0.5">
        {{ $t('lumia.lesson.reflection.questionCode', { number: index + 1 }) }}
      </span>
      <span>
        {{ question }}
      </span>
    </h4>
    <ul
      v-if="answers.length > 0"
      class="divide-surface-container-highest flex min-w-0 flex-col divide-y"
    >
      <li
        v-for="answerFromMember in answers.slice(0, MAX_ITEMS_TO_SHOW)"
        :key="answerFromMember.member.id"
        class="flex gap-2 px-4 py-2"
      >
        <BaseMemberAvatar :member="answerFromMember.member" size="32" />
        <div class="flex flex-col">
          <span class="text-title-small">{{ memberFullName(answerFromMember.member) }}</span>
          <span class="text-body-medium text-on-surface-variant italic">{{
            answerFromMember.answer
          }}</span>
        </div>
      </li>
    </ul>
    <div v-else class="flex flex-col items-center justify-center p-4">
      <span class="text-body-medium text-on-surface-variant italic">{{
        $t('lumia.lesson.reflection.noAnswers')
      }}</span>
    </div>
    <div v-if="answers.length > MAX_ITEMS_TO_SHOW" class="flex flex-row justify-end px-4 pb-4">
      <BaseTextButton color="tonalPrimary" size="XS" @click="openDialog">{{
        $t('lumia.lesson.reflection.showAllAnswers', { count: answers.length })
      }}</BaseTextButton>
    </div>
    <BaseDialog :title="question" type="basic" :is-open="isOpen" @close="closeDialog">
      <ul class="divide-outline-variant flex min-w-0 flex-col divide-y">
        <li
          v-for="answerFromMember in answers"
          :key="answerFromMember.member.id"
          class="flex gap-2 px-4 py-2"
        >
          <BaseMemberAvatar :member="answerFromMember.member" size="32" />
          <div class="flex flex-col">
            <span class="text-title-small">{{ memberFullName(answerFromMember.member) }}</span>
            <span class="text-body-medium text-on-surface-variant italic">{{
              answerFromMember.answer
            }}</span>
          </div>
        </li>
      </ul>
      <template #dismiss>
        <BaseTextButton @click="closeDialog">{{ $t('common.close') }}</BaseTextButton>
      </template>
    </BaseDialog>
  </div>
</template>

<script lang="ts" setup>
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
  import { memberFullName } from '@/core/models/member/member-name'
  import type { Member } from '@/core/models/member/member'
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import { useDialog } from '@/core/components/base/dialog/use-dialog'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'

  const MAX_ITEMS_TO_SHOW = 4

  defineProps<{
    index: number
    question: string
    answers: ReadonlyArray<{
      readonly member: Member
      readonly answer: string
    }>
  }>()

  const { isOpen, closeDialog, openDialog } = useDialog()
</script>
